import Service from "@/utils/api/service";
import Media from "@/components/share/media";
import TableLoading from "@/components/share/table-loading";
export default {
  name: "UpdatePromotion",
  props: {},
  data() {
    return {
      isUpdating: false,
      isFetching: true,
      display: {
        imagePreview: false,
        media: false,
        schedule: false,
      },
      body: {
        title: "",
        description: "",
        imageUrl: "",
        pushAt: "",
        startDate: "",
        endDate: "",
        status: "active",
      },
      data: {
        notificationDetail: "",
        media: "",
      },
      models: {
        time: "",
        date: "",
      },
      customToolbarSpecification: [
        ["bold", "italic", "underline"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        ["link"],
      ],
    };
  },
  components: {
    Media,
    TableLoading,
  },
  computed: {},
  created() {
    this.getNotification();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListPromotion",
      });
    },

    getNotification() {
      Service.getDetailPromotion(this.$route.query.id).then((response) => {
        this.isFetching = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getNotification();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.notificationDetail = response.data;
          this.getBody(response.data);
          if (response.data.imageUrl) {
            this.data.media = {
              fileName: this.getNameFromUrl(response.data.imageUrl),
              url: response.data.imageUrl,
            };
          }
        }
      });
    },

    getBody: function (data) {
      this.body = {
        title: data.title,
        description: data.description,
        imageUrl: data.imageUrl,
        startDate: new Date(data?.startedDate).toISOString().slice(0, 16),
        endDate: new Date(data?.endDate).toISOString().slice(0, 16),
        pushAt: new Date(data?.pushAt).toISOString().slice(0, 16),
        status: this.body.status,
      };
    },

    timestampFormat(dateTime) {
      const adjustedDateTime = new Date(dateTime);

      return adjustedDateTime.toISOString().slice(0, 16);
    },

    removeMedia() {
      this.data.media = "";
      this.body.imageUrl = "";
    },

    closeModal() {
      this.display = {
        imagePreview: false,
        media: false,
      };
    },

    imagePreview() {
      if (this.body.imageUrl) {
        this.display.imagePreview = true;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    chooseImage() {
      this.display.media = true;
    },

    existedMediaCallback(media) {
      this.data.media = media;
      this.body.imageUrl = media.url;
      this.closeModal();
    },

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    confirmUpdate() {
      let validatedMessage = this.validateBody(this.body);
      if (validatedMessage == "ok") {
        this.isUpdating = true;
        this.updateNotification();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.imageUrl) {
        return "Image cannot be empty!";
      } else if (!data.title) {
        return "Title cannot be empty!";
      } else if (!data.description) {
        return "Description cannot be empty!";
      }
      if (!data.pushAt) {
        return "Push At cannot be empty!";
      }
      if (!data.startDate) {
        return "Start Date cannot be empty!";
      }
      if (!data.endDate) {
        return "End Date cannot be empty!";
      } else {
        return "ok";
      }
    },

    formatDateTimePayload(dateTime) {
      const adjustedDateTime = new Date(dateTime);
      adjustedDateTime.setHours(adjustedDateTime.getHours() + 7);

      return adjustedDateTime.toISOString();
    },

    updateNotification() {
      const body = {
        title: this.body.title,
        description: this.body.description,
        imageUrl: this.body.imageUrl,
        startDate: this.formatDateTimePayload(this.body.startDate),
        endDate: this.formatDateTimePayload(this.body.endDate),
        pushAt: this.formatDateTimePayload(this.body.pushAt),
        status: this.body.status,
      };

      Service.updatePromotion(this.$route.query.id, body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.updateNotification();
              }
            });
          } else {
            this.isUpdating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isUpdating = false;
          this.goBack();
          this.$toasted.show("Notification has been updated.");
        }
      });
    },
  },
};
